module.exports = __webpack_public_path__ + "img/Picture34.ac259676.png";